import React from "react";
import { nanoid } from "nanoid";
import { useState } from "react";
import Button from "../../core/Button/Button";
import CheckBox from "../../core/Checkbox/Checkbox";
import CustomIcon from "../../core/CustomIcon/CustomIcon";
import Input from "../../core/Input/Input";
import TextArea from "../../core/Textarea/Textarea";
import useIsMobile from "../../hooks/useIsMobile";
import classes from "./ContactUs.module.scss";

import { toast } from "react-toastify";
import arrow_down from "../../../assets/icons/chevron_arrow.svg";
import { LEADS_DATA_COLLECTOR_URL } from "../../../config";
import { COUNTRY_WITH_DIALCODES } from "../../../global/constant";
import {
  DOWNLOADFILE,
  isEmailValid,
  isJsonEmpty,
  isMobileNumberValid,
  isOnlyAlphabets,
} from "../../../global/utility";
import classNames from "classnames";
import Select from "../../core/Select/Select";
import { useNavigate, Link } from "react-router-dom";
import { routePath } from "../../../routes/route";

const INDUSTRY_OPTIONS = [
  { value: "BFSIIndustry", label: "BFSI Industry" },
  { value: "TravelIndustry", label: "Travel Industry" },
  { value: "FoodIndustry", label: "Food Industry" },
  { value: "TextileIndustry", label: "Textile Industry" },
  { value: "AutomotiveIndustry", label: "Automotive Industry" },
  { value: "IronAndSteelIndustry", label: "Iron And Steel Industry" },
  { value: "Sugarindustry", label: "Sugar Industry" },
  { value: "CementIndustry", label: "Cement Industry" },
  {
    value: "ComputerInformationIndustry",
    label: "ComputerInformation Industry",
  },
  { value: "MedicalIndustry", label: "Medical Industry" },
  { value: "TelecomIndustry", label: "Telecom Industry" },
  { value: "AirlinesIndustry", label: "Airlines Industry" },
  { value: "Others", label: "Others" },
];

const ContactUsForm = ({ className, closeModal }) => {
  const isMobile = useIsMobile({ breakpoint: 625 });
  const [countryCode, setCountryCode] = useState("+91");
  const [formValues, setFormValues] = useState({});
  const [isDropdownActive, setIsDropdownActive] = useState(false);

  const navigate = useNavigate();

  const handleChange = event => {
    // console.log(" event.target.value", event.target.value);
    const name = event.target.name;
    let value = event.target.value;
    if (event.target.type === "checkbox") {
      value = event.target.checked;
    }
    setFormValues(values => ({ ...values, [name]: value }));
  };

  const handleDropdown = () => {
    setIsDropdownActive(prevState => !prevState);
  };

  const handleOption = dialCode => {
    setCountryCode(dialCode);
    /* document
      .getElementById("countryCodeDropDown")
      .classList.remove(classes.active); */
    setIsDropdownActive(prevState => !prevState);
  };

  const handleSubmit = event => {
    event.preventDefault();
    console.log("formValues", formValues);
    if (
      isJsonEmpty(formValues) ||
      // !formValues.industry ||
      !formValues.firstName ||
      !formValues.lastName ||
      !formValues.emailId ||
      !formValues.mobile ||
      // !formValues.companyWebsiteUrl ||
      // !formValues.enquiryMessage ||
      // formValues.industry === "" ||
      formValues.firstName === "" ||
      formValues.lastName === "" ||
      formValues.emailId === "" ||
      formValues.mobile === ""
      // formValues.companyWebsiteUrl === "" ||
      // formValues.enquiryMessage === ""
    ) {
      toast("Please fill all mandatory fields.", {
        toastId: "MANDATORY_TOAST",
      });
      return;
    }

    if (!formValues.tnC) {
      toast(
        "Please select terms and condition/privacy policy checkbox before submitting.",
        {
          toastId: "TNC",
        }
      );
      return;
    }

    if (
      !isOnlyAlphabets(formValues.firstName) ||
      !isOnlyAlphabets(formValues.lastName)
    ) {
      toast("Enter only alphabets in name", {
        toastId: "NAME",
      });
      return;
    }

    if (!isEmailValid(formValues.emailId)) {
      toast("Enter valid email Id", {
        toastId: "EMAIL",
      });
      return;
    }

    if (!isMobileNumberValid(formValues.mobile)) {
      toast("Enter valid mobile number", {
        toastId: "MOBILE",
      });
      return;
    }

    const requestBody = {
      firstName: formValues.firstName,
      lastName: formValues.lastName,
      emailId: formValues.emailId,
      country: countryCode,
      mobileNumber: formValues.mobile,
      industry: formValues.industry,
      companyWebsiteUrl: formValues.companyWebsiteUrl,
      enquiryMessage: formValues.enquiryMessage,
      appName: "ENTERPISE_WEBSITE",
    };

    fetch(LEADS_DATA_COLLECTOR_URL + "/save-enquiry-form", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
    })
      .then(midwareResponse => midwareResponse.json())
      .then(response => {
        console.log("closeModal: ", closeModal);
        if (closeModal) {
          closeModal();
        }
        // toast("Form submitted successfully.");
        sessionStorage.setItem("isContactUsFormSubmitted", true);
        setFormValues({});
        let selectedCaseStudyInfo = sessionStorage.getItem(
          "selectedCaseStudyInfo"
        );
        if (selectedCaseStudyInfo) {
          selectedCaseStudyInfo = JSON.parse(selectedCaseStudyInfo);
          DOWNLOADFILE(
            selectedCaseStudyInfo.filePath,
            selectedCaseStudyInfo.title + ".pdf"
          );
          sessionStorage.removeItem("selectedCaseStudyInfo");
        }
        sessionStorage.setItem("showThankYouPage", true);
        navigate(routePath.thankyou.path);
      })
      .catch(error => {
        setFormValues({});
        console.log("error", error);
        toast("An Error occurred while submitting form.");
      });
  };

  const createTncStatement = () => {
    return React.createElement(
      "div",
      null,
      React.createElement("span", {}, "I agree to the "),
      React.createElement(Link, { to: routePath.termsofservice.path }, "T&C"),
      React.createElement("span", {}, " & "),
      React.createElement(
        Link,
        { to: routePath.privacypolicy.path },
        "privacy policy"
      )
    );
  };

  return (
    <form onSubmit={handleSubmit} style={{ width: isMobile ? "100%" : "auto" }}>
      <div>
        <div
          className={classNames(classes.form, className)}
          id="fill_contactInfo"
        >
          <div
            style={{
              display: "flex",
              gap: "16px",
              flexDirection: isMobile ? "column" : "row",
            }}
          >
            <Input
              label="First Name"
              placeholder="Enter your first name"
              isRequired={true}
              name="firstName"
              value={formValues.firstName || ""}
              onChange={handleChange}
            />
            <Input
              label="Last Name"
              placeholder="Enter your last name"
              isRequired={true}
              name="lastName"
              value={formValues.lastName || ""}
              onChange={handleChange}
            />
          </div>
          <Input
            label="Your business email ID"
            placeholder="Enter your email ID"
            isRequired={true}
            name="emailId"
            value={formValues.emailId || ""}
            onChange={handleChange}
          />

          {/* <Select
            label="Industry"
            placeholder="Enter your industry"
            isRequired={true}
            name="industry"
            value={formValues.industry || ""}
            onChange={handleChange}
            options={INDUSTRY_OPTIONS}
          ></Select>

          <Input
            label="Country"
            placeholder="Enter your country"
            isRequired={true}
            name="country"
            value={formValues.country || ""}
            onChange={handleChange}
          /> */}

          <div style={{ position: "relative", cursor: "pointer" }}>
            <Input
              label="Phone number"
              placeholder="Enter your phone number"
              isRequired={true}
              /* width={isMobile ? "100%" : "65%"} */
              type="number"
              style={{ paddingLeft: "80px" }}
              name="mobile"
              value={formValues.mobile || ""}
              onChange={handleChange}
            />
            <div className={classNames(classes.dropdown)}>
              <button
                className={classNames(classes.dropdowntoggle)}
                type="button"
                onClick={handleDropdown}
              >
                <div className={classNames(classes.dropdownitem)}>
                  <div className={classes.countryCodeText}>{countryCode}</div>
                  <CustomIcon src={arrow_down} alt="dropdown" />
                </div>
              </button>
              <ul
                className={classNames(
                  classes.dropdownmenu,
                  isDropdownActive ? classes.active : ""
                )}
                id="countryCodeDropDown"
                onMouseLeave={() => setIsDropdownActive(false)}
              >
                {COUNTRY_WITH_DIALCODES.map(option => {
                  return (
                    <li
                      key={nanoid()}
                      onClick={() => handleOption(option.dialCode)}
                    >
                      <div className={classes.countryCodeText}>
                        {option.dialCode}
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>

          {/* <Input
            label="Company URL"
            placeholder="Enter your company URL"
            isRequired={true}
            name="companyWebsiteUrl"
            value={formValues.companyWebsiteUrl || ""}
            onChange={handleChange}
          /> */}

          <TextArea
            label="Message"
            placeholder="Your message"
            isRequired={false}
            name="enquiryMessage"
            value={formValues.enquiryMessage || ""}
            onChange={handleChange}
          />
          <div>
            <CheckBox
              label={createTncStatement()}
              name="tnC"
              checked={formValues.tnC || false}
              onChange={handleChange}
            />
            {/* <CheckBox
              label="I consent to receiving calls/emails from MyKare/One97's team."
              name="consent"
              checked={formValues.consent || false}
              onChange={handleChange}
            /> */}
          </div>
          <Button type="submit" label="Submit" stylebtn={{ margin: "auto" }} />
        </div>
      </div>
    </form>
  );
};

export default ContactUsForm;
